import * as React from "react";
const SvgPlus = props => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12.75 3h-1.5v8.25H3v1.5h8.25V21h1.5v-8.25H21v-1.5h-8.25V3Z" fill="currentColor" /></svg>;
export default SvgPlus;